import React from "react";
import { SvgIcon } from "@material-ui/core";
import { useTheme } from "@material-ui/core/styles";
import { Theme } from "../.themes";

interface CheckMarkProps {
  image?: {};
}

const CheckMark: React.FC<CheckMarkProps> = (props: CheckMarkProps) => {
  const theme: Theme = useTheme();

  return (
    <SvgIcon fontSize='large' style={props.image ?? {}}>
      <path
        d='M-1.2071-.5H48.5v49.7071z'
        fill={theme.palette.primary.main}
        stroke={theme.palette.primary.main}
        transform='matrix(1.24418 0 0 1.2493 3.00373 1.01704)'
      />
      <polygon
        id='Path'
        points='6 11.17 1.83 7 0.41 8.41 6 14 18 2 16.59 0.59'
        transform='translate(12 3) scale(0.5)'
        fill={theme.checkMarkColor ?? "#FFF"}
      />
    </SvgIcon>
  );
};

export default CheckMark;
